import React from 'react';

export default class Page10 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">


                                <div className="ilead-rgt ">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">


                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                                                <tbody>
                                                <tr>
                                                    <td height="50px">
                                                        <div className="indicatorlist_new">
                                                            <ul>
                                                                <li>How can you capitalise on your strongest
                                                                    areas?
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <textarea className="curved_textarea"
                                                                  style={{width:'97%'}}
                                                                  rows="5"
                                                                  cols="80"
                                                                  name="textarea"
                                                                  value={this.props.pageData?.HowCanYouCapitaliseOnYourStrongestAreas?.textarea}
                                                                  onChange={this.props.handleChangePageData('HowCanYouCapitaliseOnYourStrongestAreas')}/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td height="50px">
                                                        <div className="indicatorlist_new">
                                                            <ul>
                                                                <li>How can you use your areas of strength
                                                                    to support you in your development
                                                                    areas?
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <textarea className="curved_textarea"
                                                                  style={{width:'97%'}}
                                                                  rows="5"
                                                                  cols="80"
                                                                  name="textarea"
                                                                  value={this.props.pageData?.HowCanYouUseYourAreasOfStrength?.textarea}
                                                                  onChange={this.props.handleChangePageData('HowCanYouUseYourAreasOfStrength')}/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td height="50px">
                                                        <div className="indicatorlist_new">
                                                            <ul>
                                                                <li>What support do you need to work on your
                                                                    development needs?
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <textarea className="curved_textarea"
                                                                  style={{width:'97%'}}
                                                                  rows="5"
                                                                  cols="80"
                                                                  name="textarea"
                                                                  value={this.props.pageData?.WhatSupportDoYouNeedToWorkOnYourDevelopmentNeeds?.textarea}
                                                                  onChange={this.props.handleChangePageData('WhatSupportDoYouNeedToWorkOnYourDevelopmentNeeds')}/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td height="50px">
                                                        <div className="indicatorlist_new">
                                                            <ul>
                                                                <li>What barriers do you face to improving
                                                                    your development needs?
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <textarea className="curved_textarea"
                                                                  style={{width:'97%'}}
                                                                  rows="5"
                                                                  cols="80"
                                                                  name="textarea"
                                                                  value={this.props.pageData?.WhatBarriersDoYouFaceToImprovingYourDevelopmentNeeds?.textarea}
                                                                  onChange={this.props.handleChangePageData('WhatBarriersDoYouFaceToImprovingYourDevelopmentNeeds')}/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td height="50px">
                                                        <div className="indicatorlist_new">
                                                            <ul>
                                                                <li>How would you overcome these barriers?
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <textarea className="curved_textarea"
                                                                  style={{width:'97%'}}
                                                                  rows="5"
                                                                  cols="80"
                                                                  name="textarea"
                                                                  value={this.props.pageData?.HowWouldYouOvercomeTheseBarriers?.textarea}
                                                                  onChange={this.props.handleChangePageData('HowWouldYouOvercomeTheseBarriers')}/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td height="50px">
                                                        <div className="indicatorlist_new">
                                                            <ul>
                                                                <li>What would make the biggest, overall
                                                                    difference to you in developing
                                                                    strategic goals?
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <textarea className="curved_textarea"
                                                                  style={{width:'97%'}}
                                                                  rows="5"
                                                                  cols="80"
                                                                  name="textarea"
                                                                  value={this.props.pageData?.WhatWouldMakeTheBiggestOverallDifference?.textarea}
                                                                  onChange={this.props.handleChangePageData('WhatWouldMakeTheBiggestOverallDifference')}/>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <div className="border_subtitle"
                                                 style={{paddingTop:'20px'}}>Communication
                                            </div>
                                            <p>Consider how you will communicate your vision or strategy to
                                                others involved in carrying out the work or those
                                                who will be affected by the proposal. This should always be
                                                clear and concise with consideration given to recipients’
                                                requirements – how much detail people need. Also consider
                                                whether they need to know the whole process or focus on
                                                certain
                                                aspects, such as giving each employee a card with the
                                                mission statement on it or publishing portions of your plan
                                                in a regular
                                                newsletter.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page9')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.savePageData('Page11')}
                                                     className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}